import { useMutation } from '@tanstack/react-query'
import { postCreateContactBankAccountTwoFactorAuth } from 'services/ContactService'

export const useCreateContactBankAccount2FAMutation = () => {
  return useMutation({
    mutationFn: postCreateContactBankAccountTwoFactorAuth,
  })
}
